export default __webpack_public_path__ + "static/media/arrow-back.556b1897.svg";